import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'
import moment from 'moment'

const urlAtaRegistroPreco = '/service/materiais/ataRegistroPreco/'

class ConsultaAtaRegistroPrecoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms ? config.adms : []
        this.state = {
            adms: adms,
        }
    }

    consultar(filtro) {
        let data = {
            administracao: filtro.administracao.length > 0 ? filtro.administracao.map(e => e.value) : this.state.adms,
            ativo: filtro.ativo ? filtro.ativo.value : null,
            exercicio: filtro.exercicio ? filtro.exercicio : null,
            numero: filtro.numero ? filtro.numero : null,
            exercicioLicitacao: filtro.exercicioLicitacao ? filtro.exercicioLicitacao : null,
            numeroLicitacao: filtro.numeroLicitacao ? filtro.numeroLicitacao : null,
            objeto: filtro.objeto ? filtro.objeto : null,
            dataFim: {
                inicio: filtro.dataFimInicial ? moment(filtro.dataFimInicial).format('YYYY-MM-DD') : '',
                fim: filtro.dataFimFinal ? moment(filtro.dataFimFinal).format('YYYY-MM-DD') : '',
            },
        }
        return this.conex.post(urlAtaRegistroPreco + 'consultaAtaRegistroPreco/', JSON.stringify(data))
    }
}

export default ConsultaAtaRegistroPrecoService
